import request from 'utils/request'
import { MCAIS020CreateRequest } from 'types/MCAIS020/MCAIS020CreateRequest'

export const mediaNameIns = (account:MCAIS020CreateRequest) =>
request({
    url:'/MCAIS020/create',
    method: 'post',
    data:account,
})